export const LocalStorageLanguage: string = 'default-lang'
export const JWT: string = 'JWT'
export const PageSize: number = 10
export const MaxPages: number = 10
export const ShowLoadingAfterMs: number = 200

export function addStar(value: string): string {
    return `${value} *`
}
